import axios from 'axios'
import { logoutAction } from '../../redux/actions/LoginActions'
import { AppDispatch } from '../../redux/utils/AppDispatch'
import config from './config'

const API = axios.create({
  baseURL: config.api_url,
  headers: config.headers,
  timeout: 1500000,
})

const JWT_PATTERN = /^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]*$/

export const setAxiosToken = (token, sessionType) => {
  if (typeof token !== 'string' || !JWT_PATTERN.test(token.trim())) {
    console.error('setAxiosToken: token inválido, se ignora')
    return
  }
  const safeToken = token.trim()
  const safeSessionType = typeof sessionType === 'string' ? sessionType.trim() : ''
  localStorage.setItem('auth_token', safeToken)
  localStorage.setItem('session_type', safeSessionType)
}

export const removeAxiosToken = () => {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('session_type')
}

// For all requests
API.interceptors.request.use((req) => {
  const localToken = localStorage.getItem('auth_token')
  if (localToken) {
    req.headers.common.Authorization = `Bearer ${localToken}`
  }
  return req
})

// For all responses
API.interceptors.response.use(
  (res) => {
    console.log('interceptor response', res.config.url, res.data)
    return res
  },
  (err) => {
    console.log('interceptor error', err.response)
    if (err.response.status === 401) {
      AppDispatch(logoutAction())
    }
    return Promise.reject(err)
  }
)

export default API
